import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Modal,
  Input,
  Form,
  Checkbox,
  Radio,
  Col,
  Row,
  Select,
} from 'antd';
import styles from './dashboard.module.sass';

class DetailsModal extends Component {
  state = {
    startWithBlank: false,
  };

  constructor(props) {
    super(props);
    this.form = React.createRef();
  }

  handleSubmit = async () => {
    const { startWithBlank } = this.state;
    const ref = this.form.current;
    try {
      await ref.validateFields();
      const data = ref.getFieldsValue();

      this.props.onSubmit({
        title: data.title,
        description: data.description,
        is_public: data.is_public,
        uuid: startWithBlank ? null : data.dashboardToClone,
      });
      ref.resetFields();
    } catch (e) {}
  };

  handleStartWithBlankToggle = () => {
    this.setState((prevState) => ({
      startWithBlank: !prevState.startWithBlank,
    }));
  };

  render() {
    const { show, dashboards } = this.props;
    const { startWithBlank } = this.state;
    if (!show) return null;
    return (
      <Modal
        title="Create Dashboard"
        visible
        onCancel={this.props.onCancel}
        footer={[
          <Button key="cancel" onClick={this.props.onCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={this.handleSubmit}>
            Create
          </Button>,
        ]}
      >
        <Form
          layout="vertical"
          ref={this.form}
          initialValues={{
            is_public: true,
          }}
        >
          <Row>
            <Col span={12}>
              <Checkbox
                className={styles.blank_dashboard_checkbox}
                checked={startWithBlank}
                onChange={this.handleStartWithBlankToggle}
              >
                Start with Blank Dashboard
              </Checkbox>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Start From Existing Dashboard"
                rules={[
                  {
                    required: !startWithBlank,
                    message: 'Select Dashboard',
                  },
                ]}
                name="dashboardToClone"
              >
                <Select disabled={startWithBlank} options={dashboards} />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            label="Dashboard Name"
            name="title"
            rules={[
              {
                required: true,
                message: 'Name is required',
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item label="Description" name="description">
            <Input.TextArea />
          </Form.Item>
          <Form.Item name="is_public" label="Mark Dashboard as">
            <Radio.Group>
              <Radio className={styles.radio} value={true}>
                Public
              </Radio>
              <Radio className={styles.radio} value={false}>
                Private
              </Radio>
            </Radio.Group>
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

DetailsModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  dashboards: PropTypes.arrayOf(PropTypes.object).isRequired,
  show: PropTypes.bool.isRequired,
};

export default DetailsModal;
